module.exports = __webpack_public_path__ + "new-whatsapp-icon-md.svg?bf1434167dd9697d9cf33c1c3ba76f68";